import Loader from "@/atoms-react/loader/Loader.react";
import { EmptyPageCactusAnimation } from "@/components/animations/empty-cactus/index.react";
import { OlkyPassProLinkType } from "@/features/company/types";
import { useUser } from "@/features/user/hooks/use-user";
import { RepresentativeItem } from "..";
import { RepresentativeTableHeader } from "./representative-table-header";
import { RepresentativeTableItem } from "./representative-table-item";

type ListCompanyPropsType = {
  type: OlkyPassProLinkType;
  representativeList: RepresentativeItem[];
  actionEnabled: boolean;

  companyStatus?: Date | null;
  isAdminCompanyStatus: boolean;
  isPendingCompaniesQuery?: boolean;

  openEdit: (data: RepresentativeItem) => void;
  openDelete: (link: RepresentativeItem) => void;
  openDuplicate?: (link: RepresentativeItem) => void;

  openInvite: (link: RepresentativeItem) => void;
  openInviteCreate: (link: RepresentativeItem) => void;
};

export const ListCompanyRepresentative = ({
  type,
  representativeList,
  companyStatus,
  isAdminCompanyStatus,
  isPendingCompaniesQuery,
  openEdit,
  openDelete,
  openDuplicate,
  openInvite,
  openInviteCreate,
  actionEnabled
}: ListCompanyPropsType) => {
  const { useUserProfile } = useUser();
  const { data: user, isLoading: isUserLoading } = useUserProfile();

  return (
    <div className="h-auto overflow-visible rounded-sm border-2 border-slate-50 px-2 py-6 lg:border-0 lg:p-0 dark:border-2 dark:border-slate-700 dark:lg:border-0">
      <div className="flex flex-col">
        <RepresentativeTableHeader
          type={type}
          enableActions={!companyStatus || isAdminCompanyStatus}
        />
        {isPendingCompaniesQuery || isUserLoading ? (
          <div className="flex h-full min-w-sm flex-row justify-center px-4 py-14 lg:min-w-0">
            <div className="flex h-max flex-col justify-center">
              <Loader />
            </div>
          </div>
        ) : (
          <div className="mt-4 min-w-sm rounded-sm rounded-sm border-slate-50 px-4 lg:min-w-0 lg:border-2 dark:border-slate-700">
            {representativeList?.length > 0 ? (
              representativeList.map((representativeItem: RepresentativeItem, index) => (
                <RepresentativeTableItem
                  key={`representativeItem-${representativeItem.uuid}`}
                  actionEnabled={actionEnabled}
                  realIdentityUuid={user?.naturalPerson.UUID}
                  linkType={type}
                  link={representativeItem}
                  isLast={index === representativeList.length - 1}
                  enableActions={!companyStatus || isAdminCompanyStatus}
                  openDelete={openDelete}
                  openEdit={openEdit}
                  openInvite={openInvite}
                  openInviteCreate={openInviteCreate}
                  openDuplicate={openDuplicate}
                />
              ))
            ) : (
              <div className="flex h-full flex-row justify-center py-14">
                <div className="flex h-max flex-col justify-center">
                  <EmptyPageCactusAnimation />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
